import { results } from "../data/results"

export const RESULT_IDS = results
  .map((d) => Number(d.resultId))
  .sort((a, b) => a - b)

export const BREAKPOINT = 500 // px

export const ANIMATION_DURATION = 0.75 // seconds

export const CARD_VIZ_HEIGHT = 140
export const CARD_VIZ_HEIGHT_MOBILE = 106
export const WIRED_NAV_BAR = 57
export const WIRED_NAV_BAR2 = 60

// For localhost debugging
// export const WIRED_NAV_BAR = 0
